import { StringTMap } from '@@types/common';
import { ForwardLog } from '@@types/Log';

import { uiState } from '~/stores/UiState';
import { action, observable, toJS } from 'mobx';
import { clone, filter, map, nth, pipe, pluck, propEq, toPairs } from 'ramda';

class ForwardLogStore {
  @observable
  forwardLogMap: StringTMap<ForwardLog> = {};

  getByChannelId = (channelId: string) => {
    return this.forwardLogMap[channelId];
  };

  @action
  setForwardLog = (channelId: string, log: ForwardLog) => {
    this.forwardLogMap = uiState.pickAndSetLruChannelIds(channelId, clone(toJS(log)))(this.forwardLogMap);
  };

  @action
  removeForwardLog = (channelId: string) => {
    delete this.forwardLogMap[channelId];
  };

  @action
  removeForwardLogByLogChannelId = (channelId: string) => {
    pipe<any, any, any, any, any>(
      toPairs,
      filter(pipe(nth(1), propEq('channelId', channelId))),
      pluck(0),
      map(this.removeForwardLog)
    )(this.forwardLogMap);
  };
}

export default ForwardLogStore;

export const forwardLogStore = new ForwardLogStore();
